'use client'

import { UserData } from '@/app/lib/definitions'
import { Input } from '@nextui-org/input'
import { useState } from 'react'

export default function UserDataForm({ user }: Readonly<{ user: UserData }>) {
    const [editing, setEditing] = useState(false)
    const [name, setName] = useState<string | null>(null)
    const [phone, setPhone] = useState<string | null>(null)

    const edit = () => {
        setEditing(!editing)
        if (editing === true && user) {
            if (name != null || phone != null) {
                if (phone != null && phone != '' && phone?.length != 10) {
                    alert(
                        'Numero di telefono non valido, inserire un numero valido e riprovare'
                    )
                    return
                }
                try {
                    fetch('/api/editUser', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            uid: user.uid,
                            name: name! ?? user.name,
                            telephoneNumber: phone ?? user.telephoneNumber,
                            email: user.email,
                            type: user.type,
                            events: user.events,
                            associationId: user.associationId,
                            preferedGames: user.preferedGames
                        }),
                    })
                } catch (error) {
                    alert(error)
                    return
                }
            }
        }
    }

    return (
        <div className="grid grid-cols-1 gap-4 text-lg">
            <div className="flex content-center justify-between">
                <p className="text-2xl font-bold">Informazioni</p>
                <button
                    onClick={() => edit()}
                    className="text-md font-light italic underline transition duration-100 ease-in-out hover:font-semibold"
                >
                    {editing ? 'Salva dati' : 'Modifica'}
                </button>
            </div>
            <Input
                id="name"
                type="text"
                label="Nome"
                defaultValue={user.name ?? '-'}
                size="lg"
                radius="none"
                variant="bordered"
                color="default"
                isDisabled={!editing}
                onValueChange={(value) => {
                    setName(value)
                }}
                classNames={{
                    label: 'z-0',
                    inputWrapper: 'border-black',
                }}
            />
            <Input
                id="email"
                type="text"
                label="Email"
                defaultValue={user.email ?? '-'}
                size="lg"
                radius="none"
                variant="bordered"
                color="default"
                isDisabled={true}
                classNames={{
                    label: 'z-0',
                    inputWrapper: 'border-black',
                }}
            />
            <Input
                id="phone"
                type="number"
                label="Telefono"
                defaultValue={user.telephoneNumber?.toString()}
                size="lg"
                radius="none"
                variant="bordered"
                color="default"
                isDisabled={!editing}
                onValueChange={(value) => {
                    setPhone(value)
                }}
                classNames={{
                    label: 'z-0',
                    inputWrapper: 'border-black',
                }}
            />
        </div>
    )
}
